import { render, staticRenderFns } from "./FootPc.vue?vue&type=template&id=4c94a4aa&scoped=true&"
import script from "./FootPc.vue?vue&type=script&lang=js&"
export * from "./FootPc.vue?vue&type=script&lang=js&"
import style0 from "./FootPc.vue?vue&type=style&index=0&id=4c94a4aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94a4aa",
  null
  
)

export default component.exports